import React from 'react'
import Head from 'next/head'
import Pitch from '@src/components/DisposalPage/Pitch'
import FeatureList from '@src/components/DisposalPage/FeatureList'
import Approach from '@src/components/DisposalPage/Approach'
import FAQ from '@src/components/DisposalPage/FAQ'
import SustainabilityDashboardPromo from '@src/components/DisposalPage/SustainabilityDashboardPromo'
import SchemaMarkup from '@src/components/SchemaMarkup'
import RelatedServices from '@src/components/RelatedServices'
import Clients from '@src/pages/LandingPage/Clients'
import Testimonials from '@src/pages/LandingPage/Testimonials'
import junkTestimonials from '@src/constants/junkTestimonials'
import TrustBox from '@src/pages/common/components/TrustBox'
import TrustedByClients from '@src/components/DisposalPage/TrustedByClients'
import pageClasses from '@src/styles/junk-removal-page.module.css'
// eslint-disable-next-line import/extensions
import tv from '../../json/tv-electronics-removal-data.json'

const tvServiceData = {
  name: 'TV and Electronics Removal and Recycling',
  description:
    'Eco-friendly TV and electronics recycling for homes and businesses nationwide. Dimension collects flat-screens, CRT tube TVs, computers, and e-waste and routes them to certified recyclers.',
  serviceType: 'Electronics Recycling',
  url: 'https://getdimension.com/tv-electronics-removal',
  provider: {
    name: 'Dimension',
    url: 'https://getdimension.com',
    address: {
      streetAddress: '2261 Market Street, #4061',
      addressLocality: 'San Francisco',
      addressRegion: 'CA',
      postalCode: '94114',
      addressCountry: 'US',
    },
    telephone: '+1 (415) 340-7182',
  },
  offers: [
    { name: 'Flat-Screen TV Recycling' },
    { name: 'CRT Tube TV and Monitor Recycling' },
    { name: 'Computer and Laptop Removal' },
    { name: 'Office E-Waste Decommissioning' },
    { name: 'Certified Electronics Recycling' },
  ],
}

const tvFAQData = {
  questions: tv.FAQContent.contentList.map((faq) => ({
    question: faq.heading.replace(/<[^>]*>/g, ''),
    answer: faq.textList.join(' '),
  })),
}

function TvElectronicsRemoval() {
  return (
    <>
      <Head>
        <title>TV &amp; Electronics Recycling and Removal | Dimension</title>
        <meta
          name="description"
          content="Eco-friendly TV and electronics recycling nationwide. Dimension collects flat-screens, CRT tube TVs, computers, and e-waste and routes them to certified recyclers. Pricing from around $79."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://getdimension.com/tv-electronics-removal" />
        <SchemaMarkup type="WebSite" />
        <SchemaMarkup type="Service" data={tvServiceData} />
        <SchemaMarkup type="FAQPage" data={tvFAQData} />
        <SchemaMarkup type="LocalBusiness" />
      </Head>
      <div className={pageClasses.root}>
        <Pitch
          variant="hazardous-waste"
          heroImage="junk"
          heading={tv.pitch.heading}
          material={tv.pitch.material}
          pitchText={tv.pitch.pitchText}
          ctaLink={tv.pitch.ctaLink}
          ctaText={tv.pitch.ctaText}
          belowCta={<TrustBox isMobile isDark={false} />}
          belowPitch={<TrustedByClients />}
        />
        <Testimonials testimonials={junkTestimonials} />
        <Clients />
        <FeatureList {...tv.solutions} />
        <SustainabilityDashboardPromo />
        <FeatureList {...tv.benefits} />
        <Approach {...tv.approach} />
        <FAQ {...tv.FAQContent} />
        <RelatedServices
          services={[
            {
              label: 'Appliance Removal',
              href: '/appliance-removal',
              description:
                'Pickup and metal recycling of refrigerators, washers, ovens, and other appliances.',
            },
            {
              label: 'Junk Removal',
              href: '/junk-removal',
              description:
                'Full-service junk hauling and whole-home or office cleanouts, priced by volume.',
            },
            {
              label: 'Furniture Removal',
              href: '/furniture-removal',
              description:
                'Convenient removal of sofas, chairs, desks, and bulky furniture, with donation and recycling first.',
            },
            {
              label: 'Mattress Removal',
              href: '/mattress-removal',
              description:
                'Cheap mattress and bed-set disposal with recycling of steel, foam, and fiber.',
            },
          ]}
        />
      </div>
    </>
  )
}

export default TvElectronicsRemoval
